module.exports = __webpack_public_path__ + "img/caution.edd71611.jpg";